module.exports = __webpack_public_path__ + "media/images/OrlandoHD-9e1547e08d775d07306f9e02fc04477b.jpg";